import { useEffect, useState } from "react"
import { useNavigate, useParams } from "react-router-dom"
import { api } from "../../../env"
import { LoadingSpinner } from "../../../components/loading"
import { formatEnum } from "../../../utils/strings"
import { getStorage, STORAGE } from "../../../utils/storage"
import { ConfirmButton } from "../../../components/ConfirmButton"
import Title from "../../../components/Title"
import CreateQuestion from "./create/CreateQuestion"
import { QuestionSymmetry } from "../../../utils/enums"

export default function Questionnaire() {

    const navigate = useNavigate()
    const { id } = useParams()
    const [questionnaire, setQuestionnaire] = useState(undefined)
    const [question, setQuestion] = useState(undefined)
    const [isAdmin, setIsAdmin] = useState(false)

    useEffect(() => setIsAdmin(getStorage(STORAGE.USER_ROLE) == 'Admin'), [])

    useEffect(() => { 
        if(id) fetchQuestionnaire()
    }, [id])

    const fetchQuestionnaire = () => {
        api.get(`questionnaires/${id}`)
            .then(res => {
                console.log(res.data)
                setQuestionnaire(res.data)
            })
            .catch(_ => {})
    }

    const onQuestionSaved = () => {
        setQuestion(undefined)
        setQuestionnaire(undefined)
        fetchQuestionnaire()
    }

    const onDelete = () => {
        api.delete(`questionnaires/${id}`)
            .then(() => {
                navigate('../')
            })
            .catch(() => { })
    }

    return(<div className="standard-padding page-m-centered">
        {!questionnaire && <LoadingSpinner className={'dashed-card flex columns center standard-padding'} label={'Loading ...'}/>}
        {questionnaire && !question && <>
            <div className="flex space-between center v-spacer-xs gap-xs">
                <Title>{questionnaire?.name}</Title>
                {isAdmin && <ConfirmButton label={'Delete'} onClick={onDelete}/>}
            </div>
            {questionnaire?.questions?.sort((a, b) => a.order - b.order).map(question => <div className="card v-spacer-xs">
                <div className="flex center gap-l v-spacer-m">
                    <p className=" bold neutral">{question.order}.</p>
                    <div className="w-100">
                        <div className="flex center gap-s">
                            <p className="bold card-label-s neutral">FOR MENTOR:</p>
                            <p className={`medium card-body ${question?.questionSymmetry == QuestionSymmetry.MENTEE ? 'neutral' : ''}`}>{question?.questionSymmetry == QuestionSymmetry.MENTEE ? 'Only For Mentee' : question.textMentor}</p>
                        </div>
                        <hr className="o-25 v-spacer-xxs vi-spacer-xxs"/>
                        <div className="flex center gap-s">
                            <p className="bold card-label-s neutral h-spacer-xxs">FOR MENTEE:</p>
                            <p className={`medium card-body ${question?.questionSymmetry == QuestionSymmetry.MENTOR ? 'neutral' : ''}`}>{question?.questionSymmetry == QuestionSymmetry.MENTOR ? 'Only For Mentor' : question.textMentee}</p>
                        </div>
                    </div>
                </div>
                <div className="vi-spacer-s flex center wrap gap-xxs">
                    <span className="chip transparent bold card-label accent flex center gap-xs" style={{paddingLeft: '6px'}}><span className="material-symbols-outlined scale-xs">release_alert</span> {Math.round(question.weight * 100)}%</span>
                    <span className="chip transparent bold card-label accent flex center gap-xs" style={{paddingLeft: '6px'}}><span className="material-symbols-outlined scale-xs">speaker_notes</span> {formatEnum(question.answerType)}</span>
                    <span className="chip transparent bold card-label accent flex center gap-xs" style={{paddingLeft: '6px'}}><span className="material-symbols-outlined scale-xs">forum</span> {question.selector ? formatEnum(question.selector) : formatEnum(question.questionType)}</span>
                </div>
                {(question?.answersMentor ?? []).length > 0 && (question?.answersMentee ?? []).length > 0 && <div className="two-columns gap-m vi-spacer-m">
                    {[question.answersMentor, question.answersMentee].map((answers, roleIdx) => <div className="standard-padding-xs">
                        <p className="bold card-label-s neutral text-center v-spacer-xs">{roleIdx == 0 ? 'MENTORS' : 'MENTEES'} ANSWERS</p>
                        {answers?.map(answer => <p className="card-body regular">- {answer}</p>)}
                    </div>)}
                </div>}
                {getStorage(STORAGE.IS_ADMIN) && <div className="flex justify-end vi-spacer-m">
                    <button className="elevated" onClick={() => setQuestion(question)}>Edit</button>
                </div>}
            </div>)}
        </>}
        {question && <CreateQuestion question={question} onAdd={onQuestionSaved} onCancel={onQuestionSaved}/>}
    </div>)
}